import { Box, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useMovieFinder } from '@/logic/state';

interface TimeDurationItemProps {
  label: string;
  selectTimeDuration: (label: string) => void;
}

export const TimeDurationItem: FC<TimeDurationItemProps> = ({
  label,
  selectTimeDuration,
}) => {
  const theme = useTheme();
  const selectedTimeDuration = useMovieFinder(s => s.selectedTimeDuration, shallow);

  return (
    <Box
      sx={{
        backgroundColor:
          selectedTimeDuration === label
            ? theme.palette.primary.main
            : theme.palette.common.white,
        height: pxToRem(86),
        borderRadius: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transitionDuration: '300ms',
        '&:hover': {
          transform: 'scale(1.05)',
        },
      }}
      onClick={() => selectTimeDuration(label)}
    >
      <Typography
        sx={{
          color:
            selectedTimeDuration === label
              ? theme.palette.common.white
              : theme.palette.grey[80],
          fontSize: {
            mobile: '14px',
            tablet: pxToRem(16),
          },
          fontWeight: 700,
        }}
      >
        <FormattedMessage id={`movie.finder.showtimes.${label.toLocaleLowerCase()}`} />
      </Typography>
    </Box>
  );
};
